import Link from 'next/link'
import styles from './style.module.scss'

type Props = {
  path?: string
  title: string
}

export const MenuLinkButton = ({ path = '/', title }: Props) => {
  return (
    <Link href={path} className={styles.menuLink}>
      <span>{title}</span>
      <span className={styles.arrow} aria-hidden="true"></span>
    </Link>
  )
}

export default MenuLinkButton
